<script>
import { A11y } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/swiper-vue"
import CurrentBasket from "@/components/mobilepos/button-view/CurrentBasket.vue"
import ItemSelectionMixin from "@/mixins/item-selection.mixin"
import Items from "./Items.vue"
import CategoryList from "@/components/CategoryList.vue"

export default {
  name: "ItemSelection",

  props: ["area_id", "table_id"],
  emits: ["openLineNote"],
  inject: ["swiperSlide", "openBasket", "openCurrentBasket", "addQuantity"],

  mixins: [ItemSelectionMixin],
  components: {
    CategoryList,
    CurrentBasket,
    Items,
    SwiperSlide,
    Swiper,
  },

  data: () => ({
    swiper: null,
    modules: [A11y],
  }),

  provide() {
    return {
      itemAdd: this.itemAdd,
      itemClear: this.itemClear,
    }
  },

  mounted () {
    void this.getItems()
  },
  methods: {
    selectGroup(group) {
      this.selectedGroupId = group?.id ?? null

      const index = !this.selectedGroupId
        ? this.groups.length
        : this.groups.findIndex((g) => String(g.id) === String(this.selectedGroupId))

      this.swiper?.slideTo?.(index, 350)
    },

    onSlideChange(swiper) {
      const i = swiper.activeIndex
      const isLastSlide = i === this.groups.length

      this.selectedGroupId = isLastSlide ? null : this.groups[i].id
    },
  },
}
</script>

<template>
  <div class="px-3">
    <CurrentBasket
      :last-added-item-id="lastAddedItemId"
      @item-add="(line) => addQuantity(line)"
      @open-basket="openBasket"
      @open-current-basket="openCurrentBasket"
      @open-line-note="$emit('openLineNote', $event)"
    />
  </div>

  <nav class="nav-categories px-3 py-3 no-swiping">
    <div
      ref="groupRef"
      v-if="groups.length > 0"
      class="w-full"
    >
      <CategoryList
        @select-category="selectGroup"
        :groups="groups"
        :selected-group-id="selectedGroupId"
        :border-active-color="'#0e9f85'"
        :select-all="true"
        :show-select-at-first="false"
        :item-class="'text-lg'"
        :item-active-class="'text-sjefgreen-500 border-b-2'"
      />
    </div>
  </nav>

  <div class="flex-1 flex-shrink-0 h-full overflow-hidden">
    <swiper
      v-if="groups.length > 0"
      ref="swiper"
      :nested="true"
      :modules="modules"
      :slides-per-view="1"
      :space-between="0"
      @swiper="(instance) => (swiper = instance)"
      @slide-change="onSlideChange"
      class="h-full text-left"
    >
      <swiper-slide
        v-for="(group, index) in groups"
        :key="index"
        class="h-full px-3"
      >
        <div class="h-full overflow-y-auto">
          <Items
            :group="group"
            :items="indexedItems?.[group.id] ?? []"
          />
        </div>
      </swiper-slide>

      <swiper-slide class="h-full px-3">
        <div class="pb-3">
          <input
            type="search"
            v-model="searchquery"
            placeholder="Zoeken"
            class="rounded bg-gray-100 py-1 px-2 block w-full search focus:outline-none"
          />
        </div>

        <div class="h-full overflow-y-auto">
          <Items
            :items="allItems"
            :search="searchquery"
          />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
